import * as React from "react";

import withIsVisibleHOC from "@client/hocs/withIsVisible";
import Login from "./Login/container";
import User from "./User/container";

const UserLogin = () => (
  <div className="topbar-dropdown wsc-logins">
    <a className="title">
      <i className="far fa-lock"></i>
    </a>
    <div className="dropdown-list">
      <Login />
      <User />
    </div>
  </div>
);
export default withIsVisibleHOC(UserLogin);
